import locale from "./en";
export default locale;



// WEBPACK FOOTER //
// ./src/i18n/index.ts